/** Rendered while a lazy route chunk loads on first page load (dashboard, admin). */
export function EmptyFallback() {
  return null;
}
